// ======================================================================
// FILE:
// src/modules/service_crm/tickets/components/ServiceTicketTabView.js
//
// MODULE: Service CRM
// FEATURE: Service Ticket Tab View
// ======================================================================

import React from "react";

export default function ServiceTicketTabView({

  activeTab,

  setActiveTab,

  renderOverview,

  renderOperations,

  renderExperience,

  renderTimeline,
}) {

  // -------------------------------------------------------------------
  // TABS
  // -------------------------------------------------------------------
  const tabs = [

    {
      key: "overview",
      label: "Overview",
    },

    {
      key: "operations",
      label: "Operations",
    },

    {
      key: "experience",
      label:
        "Customer Experience",
    },

    {
      key: "timeline",
      label: "Timeline",
    },
  ];

  // -------------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------------
  return (

    <div>

      {/* ========================================================= */}
      {/* TAB HEADER */}
      {/* ========================================================= */}

      <div
        style={{

          display: "flex",

          gap: 10,

          flexWrap: "wrap",

          marginBottom: 20,
        }}
      >

        {tabs.map((tab) => (

          <button
            key={tab.key}

            type="button"

            onClick={() =>
              setActiveTab(tab.key)
            }

            style={{

              border: "none",

              borderRadius: 10,

              padding:
                "10px 18px",

              background:
                activeTab === tab.key
                  ? "linear-gradient(90deg, #0d6efd, #3d8bfd)"
                  : "#fff",

              color:
                activeTab === tab.key
                  ? "#fff"
                  : "#212529",

              fontWeight: 600,

              boxShadow:
                activeTab === tab.key
                  ? "0 4px 12px rgba(13,110,253,0.25)"
                  : "0 2px 6px rgba(0,0,0,0.08)",

              cursor: "pointer",

              transition:
                "0.2s ease",
            }}
          >
            {tab.label}
          </button>
        ))}

      </div>

      {/* ========================================================= */}
      {/* TAB CONTENT */}
      {/* ========================================================= */}

      {activeTab === "overview"
        && renderOverview()}

      {activeTab === "operations"
        && renderOperations()}

      {activeTab === "experience"
        && renderExperience()}

      {activeTab === "timeline"
        && renderTimeline()}

    </div>
  );
}